const breakpoints = {
	sm: '768px',
	md: '960px',
	lg: '1200px',
	xl: '1536px',
};

export default breakpoints;
